import React from "react";
import SettingsRole from "./views/SettingsRolePage";
import SettingsRoleContent from "../../constants/contentFile.json";
import { SettingsRoleContextProvider } from "./SettingsRoleView";

const SettingsRolePage = () => {
  return (
    <SettingsRoleContextProvider>
      <SettingsRole textContent={SettingsRoleContent.settings} />
    </SettingsRoleContextProvider>
  );
};

export default SettingsRolePage;
